import React from 'react';
import classnames from 'classnames';
import { useInView } from 'react-intersection-observer';

import { InnerBlocks } from '../assets/components';

import { getColorClassName, __experimentalGetGradientClass } from '@wordpress/block-editor';

import {
  IMAGE_BACKGROUND_TYPE,
  VIDEO_BACKGROUND_TYPE,
  backgroundImageStyles,
  dimRatioToClass,
} from './shared';

async function loadPolyfills() {
  if (typeof window.IntersectionObserver === 'undefined') {
    await import('intersection-observer');
  }
}

loadPolyfills();

export function HeroSection({ data, ...rest }) {
  const [ref, inView] = useInView({
    triggerOnce: true,
    rootMargin: '200px 0px 200px 0px',
    threshold: 0,
  });
  const { attributes, innerBlocks } = data;

  const {
    tagName: Tag,
    blockClass,
    backgroundType,
    gradient,
    customGradient,
    customOverlayColor,
    dimRatio,
    focalPoint,
    hasParallax,
    overlayColor,
    url,
    anchor,
  } = attributes;

  const overlayColorClass = getColorClassName('background-color', overlayColor);
  const gradientClass = __experimentalGetGradientClass(gradient);

  const blockClasses = classnames(blockClass, dimRatioToClass(dimRatio), overlayColorClass, {
    'has-background-dim': dimRatio !== 0,
    'has-parallax': hasParallax,
    'has-background-gradient': gradient || customGradient,
    [gradientClass]: !url && gradientClass,
  });

  const style =
    backgroundType === IMAGE_BACKGROUND_TYPE && inView ? backgroundImageStyles(url) : {};

  if (!overlayColorClass) {
    style.backgroundColor = customOverlayColor;
  }

  if (focalPoint && !hasParallax) {
    style.backgroundPosition = `${Math.round(focalPoint.x * 100)}% ${Math.round(
      focalPoint.y * 100,
    )}%`;
  }

  if (customGradient && !url) {
    style.background = customGradient;
  }

  return (
    <>
      <Tag ref={ref} id={anchor} className={blockClasses} style={style}>
        {url && (gradient || customGradient) && dimRatio !== 0 && (
          <span
            aria-hidden="true"
            className={classnames('wp-block-cover__gradient-background', gradientClass)}
            style={customGradient ? { background: customGradient } : undefined}
          />
        )}
        {VIDEO_BACKGROUND_TYPE === backgroundType && url && (
          <video className="wp-block-cover__video-background" autoPlay muted loop src={url} />
        )}

        <InnerBlocks className="inner-wrap" blocks={innerBlocks} />
      </Tag>
    </>
  );
}
